import { ERROR_CODES } from '@shinetools/errors';
import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    errors: {
      [ERROR_CODES.COMPANY_INVITATION_QUOTA_LIMIT_REACHED]:
        'It looks like you ran out of usable invitations. Please refresh the page and try again.',
      [ERROR_CODES.EMAIL_ALREADY_EXISTS]:
        'This email is already used. Please try again with an other email.',
      invitationError:
        'Due to a technical issue, we were unable to send the invite. Please try again and do not hesitate to contact us if the problem persists.',
    },
  },
  fr: {
    errors: {
      invitationError:
        'Suite à une erreur technique, nous n’avons pas pu envoyer l’invitation. Veuillez réessayer et n’hésitez pas à nous contacter si le problème persiste.',
      [ERROR_CODES.COMPANY_INVITATION_QUOTA_LIMIT_REACHED]:
        "Il semblerait qu'il ne vous reste plus d'invitations utilisables. Veuillez rafraîchir la page et réessayer.",
      [ERROR_CODES.EMAIL_ALREADY_EXISTS]:
        'Cette adresse e-mail est déjà utilisée. Veuillez réessayer avec une autre adresse e-mail.',
    },
  },
} as const);

export default locales;
